import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { withRouter } from "react-router";
import AuthHoc from '../Common/CommonHoc/AuthHoc';
import ProfileBanner from './Common/profileSettingsBanner';
import { getLocalizedStrings } from './profileSettingsLocalizedStrings';
import GeneralSettings from './ProfileGeneralSettings/generalSettingsContainer';
import NotificationSettings from './ProfileNotificationSettings/notificationSettingsContainer';
import ManageAccount from "./ManageAccount/manageAccountContainer";
import classes from './profileSettings.scss';
import LoaderPopup from "../Common/CommonComponents/LoadingSpinner/loadingSpinner";

export default class ProfileSettingsContainer extends React.Component {
    constructor(props) {
        super(props);
        if(app.appService.getUserInfo().profileData.profile.userType==="WEBUSER" || app.appService.getUserInfo().profileData.profile.userType==="CI"){
          app.appUtil.navigateTo('/mysce/websettings#profile'); 
        }
        this.state = {
          profileData: '',
          webUser:false,
          bPNumberFound:true,
          bpNumber: null,
          userType: '',
          showVerificationError: false,
          verificationErrMsg: '',
          loaderDialogBox: true
        };
        this.strings = getLocalizedStrings('GeneralSettings');
        this.userGroups = app.appUtil.getAppConstants().USER_GROUPS;
      }

    componentDidMount(){
        this.setState({loaderDialogBox:false});
    }
     
      componentWillMount() {
          if(app.appService.isCpcGuestUser()) app.pubSubService.publish('startIdleSessionExpiring', 'Start Idle Session is going to expire');

          if(app.appService.isAuthenticated() || app.appService.isCpcGuestUser()){
              this.getProfileData();
          }
      }

      componentWillUnmount() {
        app.appUtil.unsetFontAwesomeNesting();
        if(app.appService.isCpcGuestUser()) app.pubSubService.publish('stopIdleSessionExpiring', 'Stop Idle Session');
      }

      getProfileData() {
        let loggedInProfileData = app.appService.getUserInfo().profileData.profile;
        let userGrp = app.appService.getPrioritisedUserGrp();
        this.setState({profileData:loggedInProfileData, userType: userGrp});
      }

      webUser(bpfound,bpnumber){
        this.setState({ webUser: true, bPNumberFound: bpfound, bpNumber: bpnumber });
      }
      bPNumberFound(bpfound){
        this.setState({bPNumberFound:bpfound});
      }
      updateMailingAddress(){
        app.appUtil.navigateTo(app.appUtil.getAppRoutes().PROFILE_SETTINGS.UPDATE_MAILING_ADDRESS);
        app.appService.setLocalStorage('updateMailingFromProfile', app.appUtil.getAppRoutes().BILLING.SETTINGS_PROFILE);
      }

      getNotificationViewToShow = () => {
        if((this.state.userType === this.userGroups.THIRDPARTY) || (this.state.userType === this.userGroups.BENCHMARK) || (!this.state.bPNumberFound) || (_.isEmpty(this.state.userType))){
          return( null );
        }else{
          return(
            <NotificationSettings webUser={this.webUser.bind(this)} bPNumberFound={this.bPNumberFound.bind(this)} />
          );
        }
      }

      getAllSectionsToShow(showNotification) {
        if((this.state.userType === this.userGroups.GUESTUSERS)){
          return (
            <div className="row">
                <div className="col-xs-12">
                  <div className={classes.sceProfSetNotificationCenter}>{showNotification}</div>
                </div>
            </div>
          );
        } else {
          return (
            <div className="row">
              <div className="col-md-6">
                <div><GeneralSettings profileData={this.state.profileData} setVerficationError={this.setVerficationError.bind(this)} /></div>
                <div><ManageAccount userType={this.state.userType} bPNumberFound={this.state.bPNumberFound} bpNumber={this.state.bpNumber} /></div>
              </div>
              <div className="col-md-6">
                <div>{showNotification}</div>
                <div className={classes.updateAddrpadding}>
                    <div className={classes.updateAddrLabel}>{this.strings.updateAddrLabel}</div>
                    <div><p className={classes.updateAddrInfo}>{this.strings.updateAddrInfo}</p></div>
                    <div className={classes.updateLinkPadding}><a className={classes.sceSmLink} href="javascript:void(0)" onClick={this.updateMailingAddress} >{this.strings.updateAddrLink}</a></div>
                </div>
              </div>
            </div>
          );
        }
      }

      setVerficationError = (verErrCode) => {
        let errorMesg;
        if(verErrCode){
          errorMesg = this.strings.invalidActivationErrMsg;
        }
        this.setState({showVerificationError:true,verificationErrMsg:errorMesg});
      }

      render() {
        let showNotification = this.getNotificationViewToShow();
        let showSections = this.getAllSectionsToShow(showNotification);
        let displayBanner = (this.props.noBanner!==undefined?!this.props.noBanner:true);
        const view = this.state.showVerificationError ? 
                     <div className={classes.cardPadding}>
                       <div className={classes.Card}>{this.state.verificationErrMsg}</div> 
                     </div> : 
                     <div className="col-xs-12">
                        {displayBanner?<div className='row'>
                        <div className="col-xs-12">
                          <ProfileBanner message={this.strings.profileSettingsLabel} />
                        </div>
                        </div>:null}
                        {showSections}
                     </div>;
        return(
            <div>
               {this.state.loaderDialogBox ? <LoaderPopup /> : null}
                {view}
            </div>
        );
      }
          
      
}

(function () {
  AppModule.init(fetchLibs);
  app.appUtil.setFontAwesomeNesting();
  if (!app.appService.isAuthenticated()){
    app.appService.customPostLoginNavigation(app.appUtil.getAppRoutes().PROFILE_SETTINGS.PROFILE_SETTINGS_LANDING);
  }
})();

function fetchLibs() {
  app.appUtil.appDependencyService.loadDependencyLibs(renderComponent, 24);
}

function renderComponent() {
  const url = app.appUtil.getQueryParameters(window.location.href);
  const ProfileSettingsContainer1 = (url && url.token && url.oktaId) ? withRouter(ProfileSettingsContainer) : AuthHoc(withRouter(ProfileSettingsContainer), true);
  ReactDOM.render(
    <Router>
      <ProfileSettingsContainer1 />
    </Router>,
    document.getElementById("react-profile-settings")
  );
}
